import YoutubeVideo from './../YoutubeVideo/YoutubeVideo';
import Modal from './../Modal/Modal';
import {useEffect, useState} from 'react';

const GuideModal = ({show, onClose}) => {
    const [isShown, setIsShown] = useState(show);

    const handleClose = () => {
        onClose();
        setIsShown(false);
    };

    useEffect(() => {
        setIsShown(show);
    }, [show])

    return (
        <Modal content={<div style={{
            width: '800px',
            maxWidth: '100%',
            padding: '25px 0'
        }}><YoutubeVideo embedId="5jrX6jb2ebM" /></div>} onClose={(e) => {
            handleClose();
        }} visible={isShown}/>
    )
}

export default GuideModal;